import {Component, Input} from '@angular/core';
import {Module} from '../../models/models';

@Component({
  selector: 'app-module',
  templateUrl: './module.component.html',
  styleUrls: ['./module.component.css']
})
export class ModuleComponent {
  @Input() module: Module;
  constructor() { }
}
